<div class="center-container">
    <p>&nbsp;</p>
    <div class="formgrid grid align-items-center justify-content-center text-center">

        <div class="field col-12 md:col-12 otp-wrapper">
            <p>Sie erhalten in Kürze eine SMS mit einem Einmal-Kennwort (OTP) – einer 6-stelligen Zahlenkombination.</p>
        </div>
        <div class="field col-12 md:col-12 otp-wrapper">
            <p-inputOtp [(ngModel)]="otp" [length]="6" [integerOnly]="true"></p-inputOtp>
        </div>

        <div class="col-12 md:col-12">
            <p-button label="{{'sipo.submit' | translate}}" (onClick)="send()"></p-button>
        </div>
    </div>
</div>
